// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__wdbm1","Image":"Logo_Image__XgRy5"};